import KunLoading15 from './src/index'

KunLoading15.install = function (Vue) {
	Vue.component(KunLoading15.name, KunLoading15);
}

export default KunLoading15;
